module.exports = __webpack_public_path__ + "static/img/8.cc45db3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/zh/8.png
// module id = 5CuL
// module chunks = 0